/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const CircleArrowOutDownRight = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M12 22a10 10 0 1 1 10-10" }],
    ["path", { d: "M22 22 12 12" }],
    ["path", { d: "M22 16v6h-6" }]
  ]
];

export { CircleArrowOutDownRight as default };
//# sourceMappingURL=circle-arrow-out-down-right.js.map
